import React, { ReactNode } from "react";
import clsx from "clsx";
import styles from "./ImageRatio.module.scss";

export type ImageAspectRatio =
  | "card"
  | "card-panorama"
  | "card-compact"
  | "card-condensed"
  | "rectangular"
  | "vertical"
  | "custom";
export interface ImageRatioProps {
  ratio: ImageAspectRatio;
  className?: string;
  children: ReactNode;
}

export interface StaticImageRatioProps {
  ratio: "auto";
  width: number;
  height: number;
  className?: string;
  children: ReactNode;
}

export const ImageRatio = React.memo<ImageRatioProps | StaticImageRatioProps>(
  function ImageRatio({ className, ratio, children, ...props }) {
    const aspectRatioStyle =
      ratio == "auto"
        ? computeAspectRatioStyle(props["width"], props["height"])
        : undefined;

    const ratioClassName = clsx({
      [styles.aspectRatioAuto]: ratio == "auto",
      [styles.aspectRatioCard]: ratio == "card",
      [styles.aspectRatioCardPanorama]: ratio == "card-panorama",
      [styles.aspectRatioCardCompact]: ratio == "card-compact",
      [styles.aspectRatioCardCondensed]: ratio == "card-condensed",
      [styles.aspectRatioRectangular]: ratio == "rectangular",
      [styles.aspectRatioVertical]: ratio == "vertical",
      [styles.aspectRatioCustom]: ratio == "custom"
    });

    const newChildren = React.Children.map(children, function (child) {
      if (React.isValidElement(child)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return React.cloneElement<any>(child, {
          className: styles.imageInner
        });
      }
    });

    return (
      <div
        className={clsx(styles.image, ratioClassName, className)}
        style={aspectRatioStyle}
      >
        {newChildren}
      </div>
    );
  }
);

export const computeAspectRatioStyle = (
  width: number,
  height: number
): React.CSSProperties => {
  const defaultAspectRatioPadding = computeDefaultAspectRatio(width, height);
  return {
    "--custom-image-aspect-ratio": defaultAspectRatioPadding
  } as React.CSSProperties;
};

const computeDefaultAspectRatio = (width: number, height: number) => {
  const padding = `${(height / width) * 100}%`;
  return padding;
};
